<template>
  <div
    class="d-flex flex-wrap ga-4"
    data-qa="diagram_gender"
  >
    <div
      class="d-flex align-center gc-1"
      data-qa="diagram_gender_woman"
    >
      <span class="ui-icon-gender-female ui-icon-fz-medium primary--text" />
      <span class="text-body-2">
        Женщины – <span class="text-subtitle-2">{{ context.doctor_practice.patients_women_frequency }}%</span>
      </span>
    </div>
    <div
      class="d-flex align-center gc-1"
      data-qa="diagram_gender_man"
    >
      <span class="ui-icon-gender-male ui-icon-fz-medium primary--text" />
      <span class="text-body-2">
        Мужчины – <span class="text-subtitle-2">{{ context.doctor_practice.patients_men_frequency }}%</span>
      </span>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useContextStore } from 'src/store'
import type { ContextStore } from 'src/components/pages/[town_translit]/vrach/[doctor_translit]/SectionPractice/types'

const { context }: ContextStore = useContextStore()
</script>
